import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { deleteFoodCategoriesRequest, deleteFoodCategoriesRequestError, deleteFoodCategoriesRequestSuccess } from '../../slices/Content/DeleteFoodCategoriesSlice';


export const DeleteFoodCategoryAPI = (id) => {
    const url = `${endpoints.deleteFoodCategory}/${id}`;
    return async (dispatch) => {
        try {
            dispatch(deleteFoodCategoriesRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "DELETE",
                url: url,
            })
            return dispatch(deleteFoodCategoriesRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(deleteFoodCategoriesRequestError(_error));
        }
    };
};
